module.exports = "/assets/_next/static/images/localized_promo_bg-5d7378e2560ee414c56b6eb6200ace6d.png";